// The gender a bracket slot asks for, given its division.
//
// Used both to filter typeahead search results and to stamp the gender on a
// player created inline from that slot, so the two can never disagree.
//
//   - mixed doubles: position 1 is the female slot, position 2 the male slot
//   - men's / women's divisions: the division's gender
//   - anything else ('team' pool-play divisions, unknown/null): null, which
//     tells create_or_get_player to fall back to its own default. Passing the
//     raw division gender here used to send 'team' straight into the
//     players_gender_check constraint.
export function slotGender(divisionGender, divisionTeamSize = 1, playerPosition = null) {
  if (divisionTeamSize === 2 && divisionGender === 'mixed') {
    return playerPosition === 1 ? 'female' : 'male'
  }
  if (divisionGender === 'male' || divisionGender === 'female') {
    return divisionGender
  }
  return null
}
